import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "navBox contentBox" }
const _hoisted_2 = ["onMouseenter"]
const _hoisted_3 = ["onClick"]

import { isMobie, navTo } from "@/utils/util";
import { useRouter } from "vue-router";
import {
  getCurrentInstance,
  onMounted,
  ref,
  watch,
  onBeforeUnmount,
} from "vue";
import MenuOptions from "@/utils/menu";
import OssImg from "./ossImg.vue";

const maxScrollForEffect = 500;

export default /*@__PURE__*/_defineComponent({
  __name: 'Menu',
  props: {
  //是否首页
  isHome: {
    type: Boolean,
    default: false,
  },
},
  setup(__props, { expose: __expose }) {

const props = __props;

const { proxy } = getCurrentInstance() as any;
const router = useRouter();

const activeMenu = ref("");
const hoverMenu = ref(-1); // 当前悬停的菜单索引

// 判断当前路径是否属于某个根菜单
const isMenuActive = (menuPath: string, currentPath: string): boolean => {
  // 处理菜单路径中的 /index 后缀
  const normalizeMenuPath = menuPath.replace(/\/index$/, '');
  
  // 如果路径完全匹配
  if (currentPath === menuPath || currentPath === normalizeMenuPath) {
    return true;
  }
  
  // 检查是否是根路径的子路径（处理 /news/index 和 /news/detail 等情况）
  if (currentPath.startsWith(normalizeMenuPath + '/')) {
    return true;
  }
  
  // 特殊处理首页路径
  if (normalizeMenuPath === '/home' && (currentPath === '/' || currentPath === '' || currentPath === '/home')) {
    return true;
  }
  
  // 特殊处理客户案例详情页
  if (menuPath === '/customerCase' && currentPath.startsWith('/customerCase')) {
    return true;
  }
  
  return false;
};
const scrollY = ref(0);
const scrollLeft = ref(0);
const menu = ref(MenuOptions);
const headerRef = ref(null);

//移动端抽屉
const isDrawerOpen = ref(false);
const openIndex = ref(0);
const openSubIndex = ref(0);

// 监听路由变化
watch(
  () => router.currentRoute.value,
  (newValue: any) => {
    activeMenu.value = newValue.path;
  },
  { immediate: true, deep: true }
);

// 点击菜单跳转
const gotoMenu = (items) => {
  console.log(items);
  if (items.children) {
    return;
  }
  proxy.$router.push(items.path);
};

// 滚动监听
const handleScroll = () => {
  scrollLeft.value =
    document.documentElement.scrollLeft || document.body.scrollLeft;
  scrollY.value = window.scrollY;
};

function toggleDrawer() {
  console.log("toggleDrawer");
  isDrawerOpen.value = !isDrawerOpen.value; // 切换抽屉状态
}

/**
 * 点击一级菜单
 * @param item
 * @param index
 */
function toggleItem(item, index) {
  if (item.children) {
    // 展开或折叠二级菜单
    openIndex.value = openIndex.value === index ? null : index;
  } else {
    gotoMenu(item);
    isDrawerOpen.value = false;
  }
}
/**
 *
 * 点击二级菜单
 * @param subItem
 * @param index
 */
function toggleSubItem(subItem, index) {
  if (subItem.children) {
    openSubIndex.value = openSubIndex.value === index ? null : index;
  } else {
    gotoMenu(subItem);
    isDrawerOpen.value = false;
  }
}

onMounted(() => {
  window.addEventListener("scroll", handleScroll, true);
  handleScroll();
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", handleScroll, true);
});

__expose({
  ref: headerRef.value,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", {
    style: _normalizeStyle({
    '--bg-opacity': !__props.isHome ? 1 : Math.min(scrollY.value / maxScrollForEffect, 1),
  }),
    ref_key: "headerRef",
    ref: headerRef
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "leftLogo",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(navTo)('/home')))
      }, [
        _cache[3] || (_cache[3] = _createElementVNode("div", null, "耀客物联", -1)),
        _createVNode(OssImg, {
          class: "logoImg",
          src: "images/logo.png",
          alt: ""
        })
      ]),
      _createElementVNode("div", {
        class: "menuBox display_flex",
        style: {"padding":"0 20px"},
        onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (hoverMenu.value = -1))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.value, (items, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "menu",
            onMouseenter: ($event: any) => (hoverMenu.value = index),
            onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (hoverMenu.value = -1))
          }, [
            _createElementVNode("div", {
              class: "menuTitle",
              style: _normalizeStyle({
            color: isMenuActive(items.path, activeMenu.value) ? '#32A89E' : ''
          }),
              onClick: _withModifiers(($event: any) => (gotoMenu(items)), ["stop"])
            }, _toDisplayString(items.title), 13, _hoisted_3)
          ], 40, _hoisted_2))
        }), 128))
      ], 32)
    ])
  ], 4))
}
}

})